import { useState } from "react";
import { Form, Offcanvas, Button } from "react-bootstrap";
import { FiEye, FiEyeOff } from "react-icons/fi";

const DeleteAccount = ({ show, hide, title }) => {
  const [loader, setLoader] = useState(false);
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  return (
    <Offcanvas show={show} onHide={hide} placement="end">
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>{title}</Offcanvas.Title>
      </Offcanvas.Header>

      <Offcanvas.Body>
        <Form>
          <Form.Group className="mb-2">
            <Form.Label>Password</Form.Label>
            <div className="position-relative">
              <Form.Control
                name="userName"
                type={showPassword ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter Password"
              />
              <button
                type="button"
                className="btn-icon-show"
                onClick={() => setShowPassword(!showPassword)}
                style={{
                  position: "absolute",
                  right: "10px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  background: "none",
                  border: "none",
                  cursor: "pointer",
                  color: "#999",
                }}
              >
                {showPassword ? <FiEyeOff /> : <FiEye />}
              </button>
            </div>
          </Form.Group>
          <div className="d-flex justify-content-end gap-2 mt-3">
            <Button style={{ fontSize: 12 }} variant="light">
              Cancel
            </Button>
            <Button disabled={!password || loader} style={{ fontSize: 12 }} variant="danger">
              {title}
            </Button>
          </div>
        </Form>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default DeleteAccount;
